import React from 'react';
import { type LinkField } from 'lib/types';
import { cn } from 'lib/utils';
import { Button, Icon } from 'ui';

export type ResourceGridFooterLinksProps = {
  links?: LinkField[];
};

const ResourceGridFooterLinks = ({ links }: ResourceGridFooterLinksProps) => {
  if (!links?.length) {
    return null;
  }

  return (
    <div className="flex justify-center items-center flex-wrap gap-x-6 gap-y-4 mt-10 lg:mt-12">
      {links.map((link, index) => {
        const isExternalLink = link.target === '_blank';
        return (
          <Button
            key={index}
            href={link.href}
            target={link.target}
            variant="tertiary"
            className="block text-center"
            trackingProps={link.trackingProps}
          >
            <span>{link.text}</span>
            <Icon
              name={
                isExternalLink
                  ? 'external-link-arrow'
                  : 'internal-link-arrow-right'
              }
              className={cn(
                'inline-block h-auto shrink-0 ml-1.5 align-middle',
                {
                  'w-3': !isExternalLink,
                  'w-2.5': isExternalLink,
                }
              )}
            />
          </Button>
        );
      })}
    </div>
  );
};

export default ResourceGridFooterLinks;
